import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "16",
      height: "16",
      fill: "#FACC15",
      rx: "4"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.021 12a1 1 0 0 0 .997 1H11a1 1 0 0 0 .997-1V4c0-.552-.446-1-.997-1H5.018a1 1 0 0 0-.997 1m2.742 2h2.492m-5.224.005h.018m-.035 1.994h.017m-.034 1.993h.017M6.763 10h2.243M6.755 8h3.24"
    }, null, -1)
  ]))]))
}
export default { render: render }